/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { StockDto } from '../models/stock-dto';


/**
 * Fonctions de gestion des stocks
 */
@Injectable({
  providedIn: 'root',
})
export class StocksService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation stockGetList
   */
  static readonly StockGetListPath = '/api/stocks/list';

  /**
   * Renvoie la liste des stocks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stockGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  stockGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<StockDto>>> {

    const rb = new RequestBuilder(this.rootUrl, StocksService.StockGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<StockDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des stocks.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `stockGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stockGetList(params?: {
  }): Observable<Array<StockDto>> {

    return this.stockGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<StockDto>>) => r.body as Array<StockDto>)
    );
  }

  /**
   * Path part for operation stockLoadList
   */
  static readonly StockLoadListPath = '/api/stocks/load-list';

  /**
   * Renvoie la liste des stocks (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stockLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stockLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, StocksService.StockLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des stocks (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `stockLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stockLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.stockLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation stockGet
   */
  static readonly StockGetPath = '/api/stocks/{id}';

  /**
   * Renvoie le stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stockGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  stockGet$Response(params: {

    /**
     * Identifiant du stock
     */
    id: number;
  }): Observable<StrictHttpResponse<StockDto>> {

    const rb = new RequestBuilder(this.rootUrl, StocksService.StockGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockDto>;
      })
    );
  }

  /**
   * Renvoie le stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `stockGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stockGet(params: {

    /**
     * Identifiant du stock
     */
    id: number;
  }): Observable<StockDto> {

    return this.stockGet$Response(params).pipe(
      map((r: StrictHttpResponse<StockDto>) => r.body as StockDto)
    );
  }

  /**
   * Path part for operation stockDelete
   */
  static readonly StockDeletePath = '/api/stocks/{id}';

  /**
   * Supprime le stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stockDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  stockDelete$Response(params: {

    /**
     * Identifiant du stock à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, StocksService.StockDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `stockDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stockDelete(params: {

    /**
     * Identifiant du stock à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.stockDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation stockPut
   */
  static readonly StockPutPath = '/api/stocks';

  /**
   * Met à jour le stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stockPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stockPut$Response(params: {
    id?: number;
    body: StockDto
  }): Observable<StrictHttpResponse<StockDto>> {

    const rb = new RequestBuilder(this.rootUrl, StocksService.StockPutPath, 'put');
    if (params) {
      rb.query('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockDto>;
      })
    );
  }

  /**
   * Met à jour le stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `stockPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stockPut(params: {
    id?: number;
    body: StockDto
  }): Observable<StockDto> {

    return this.stockPut$Response(params).pipe(
      map((r: StrictHttpResponse<StockDto>) => r.body as StockDto)
    );
  }

  /**
   * Path part for operation stockPost
   */
  static readonly StockPostPath = '/api/stocks';

  /**
   * Crée le stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stockPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stockPost$Response(params: {

    /**
     * Stock
     */
    body: StockDto
  }): Observable<StrictHttpResponse<StockDto>> {

    const rb = new RequestBuilder(this.rootUrl, StocksService.StockPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockDto>;
      })
    );
  }

  /**
   * Crée le stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `stockPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stockPost(params: {

    /**
     * Stock
     */
    body: StockDto
  }): Observable<StockDto> {

    return this.stockPost$Response(params).pipe(
      map((r: StrictHttpResponse<StockDto>) => r.body as StockDto)
    );
  }

}
